import React from "react";
import apiClient from "api/client";
import {connect} from "react-redux";
import ReactJson from "react-json-view";
import {
    Checkbox,
    Col,
    ControlLabel,
    FormControl,
    FormGroup,
    HelpBlock,
    Label,
    Modal,
    OverlayTrigger,
    Row,
    Tooltip
} from "react-bootstrap";
import Card from "../Card/Card";
import Button from "../CustomButton/CustomButton";
import ReactTableV6Simple from "../CustomDataTables/ReactTableV6Simple";
import {userActions} from "../../authentication/_actions";

class DataRedisCacheManagement extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            info_tooltip: (<Tooltip id="redis_info_tooltip">Inspect key</Tooltip>),
            delete_tooltip: (<Tooltip id="redis_delete_tooltip">Delete key</Tooltip>),
            use_tooltip: (<Tooltip id="redis_use_tooltip">Use this server</Tooltip>),
            category_tooltip: (<Tooltip id="redis_category_tooltip">Load this category</Tooltip>),

            loadingOverview: false,
            loadingStats: false,
            loadingKeys: false,
            actionLoading: false,

            selectedServer: "all",
            selectedCategory: "connect",
            port: 6379,
            pattern: "*",
            limit: 100,
            autoRefreshSeconds: 0,
            lastAutoRefreshAt: null,
            keyName: "",
            includeValues: false,
            includeMemory: true,
            fullScan: false,

            overview: null,
            statsResponse: null,
            keysResponse: null,
            lastKeysMode: null,
            inspectorTitle: "API Response",
            inspectorData: null,
            successMessage: null,
            errorMessage: null,

            availableServers: [],
            categories: [],

            confirmModal: {
                show: false,
                type: null,
                title: "",
                body: "",
                payload: {}
            }
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.autoRefreshTimer = null;
    }

    componentDidMount() {
        this.refreshSummaryCards(true);

        this.syncAutoRefreshTimer();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.autoRefreshSeconds !== this.state.autoRefreshSeconds) {
            this.syncAutoRefreshTimer();
        }
    }

    componentWillUnmount() {
        this.clearAutoRefreshTimer();
    }

    getDefaultCategories() {
        return [
            {id: "connect", label: "Connect", prefixes: ["account_response", "account_auth_response", "connect_touch"]},
            {id: "auth_lookup", label: "Auth Lookup", prefixes: ["customer_by_id", "device_by_customer", "application_user_limits", "stb_device_count", "mobile_device_count"]},
            {id: "application_settings", label: "Application Settings", prefixes: ["application_settings"]},
            {id: "menu", label: "Menu", prefixes: ["menu"]},
            {id: "channels", label: "Channels", prefixes: ["channels", "channels_package", "channels_packages", "channels_categories"]},
            {id: "events", label: "Events", prefixes: ["events", "events_categories", "events_packages"]},
            {id: "sports", label: "Sports", prefixes: ["sports", "sports_package", "sports_packages", "sports_categories"]},
            {id: "video", label: "Video", prefixes: ["vod_movies", "vod_movie_details_db", "vod_movie_categories", "vod_movies_by_actor", "vod_movies_by_director", "vod_svod_price_groups", "vod_packages_application", "vod_svod_subscriptions_available", "vod_svod_subscriptions_active_full", "vod_svod_subscriptions_active_item"]},
            {id: "epg", label: "EPG", prefixes: ["epg", "epg_static_channel"]}
        ];
    }

    getApiUrl(path = "") {
        return process.env.REACT_APP_API_URL + "/RedisCache" + path;
    }

    getUserToken() {
        let user = JSON.parse(localStorage.getItem('user'));

        if (user && user.token) {
            return user.token;
        }

        return null;
    }

    getAxiosConfig(params = {}) {
        const token = this.getUserToken();

        if (!token) {
            return null;
        }

        return {
            headers: {
                'X-Id-Token': token
            },
            params: params
        };
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    getAutoRefreshSeconds() {
        const seconds = parseInt(this.state.autoRefreshSeconds, 10);

        if (Number.isNaN(seconds) || seconds < 0) {
            return 0;
        }

        return seconds;
    }

    clearAutoRefreshTimer() {
        if (this.autoRefreshTimer) {
            clearInterval(this.autoRefreshTimer);
            this.autoRefreshTimer = null;
        }
    }

    syncAutoRefreshTimer() {
        this.clearAutoRefreshTimer();

        const seconds = this.getAutoRefreshSeconds();

        if (seconds <= 0) {
            return;
        }

        this.autoRefreshTimer = setInterval(() => {
            this.runAutoRefresh();
        }, seconds * 1000);
    }

    runAutoRefresh() {
        if (this.state.loadingOverview || this.state.loadingStats || this.state.loadingKeys || this.state.actionLoading) {
            return;
        }

        this.refreshSummaryCards(true);

        if (this.state.lastKeysMode === "category") {
            this.loadCategoryKeys(this.state.selectedCategory, true);
        } else if (this.state.lastKeysMode === "keys") {
            this.loadKeys(true);
        }
    }

    refreshSummaryCards = (silent = false) => {
        return Promise.all([
            this.loadOverview(silent),
            this.loadStats(silent)
        ]).then(() => {
            this.setState({
                lastAutoRefreshAt: new Date().toISOString()
            });
        });
    }

    buildServerParams(serverOverride = null) {
        const selectedServer = serverOverride || this.state.selectedServer;
        const params = {
            port: this.state.port
        };

        if (selectedServer === "all") {
            params.all_servers = 1;
            return params;
        }

        params.server = selectedServer;
        return params;
    }

    buildListParams(serverOverride = null) {
        return {
            ...this.buildServerParams(serverOverride),
            pattern: this.state.pattern,
            limit: this.state.limit,
            include_memory: this.state.includeMemory ? 1 : 0,
            include_values: this.state.includeValues ? 1 : 0,
            full_scan: this.state.fullScan ? 1 : 0
        };
    }

    clearMessages() {
        this.setState({
            successMessage: null,
            errorMessage: null
        });
    }

    setInspector(title, payload) {
        this.setState({
            inspectorTitle: title,
            inspectorData: payload
        });
    }

    setSuccessMessage(message) {
        this.setState({
            successMessage: message,
            errorMessage: null
        });
    }

    setErrorMessage(message) {
        this.setState({
            errorMessage: message,
            successMessage: null
        });
    }

    buildErrorMessage(error) {
        if (!error) {
            return "Unknown Redis API error.";
        }

        if (error.response) {
            const responseData = error.response.data;

            if (typeof responseData === "string" && responseData.length > 0) {
                return responseData;
            }

            if (responseData && responseData.error) {
                return responseData.error;
            }

            if (responseData && responseData.message) {
                return responseData.message;
            }
        }

        if (error.message) {
            return error.message;
        }

        return "Unknown Redis API error.";
    }

    loadOverview = (silent = false) => {
        const axiosConfig = this.getAxiosConfig();

        if (!axiosConfig) {
            return Promise.resolve();
        }

        this.setState({loadingOverview: true});

        return apiClient.get(this.getApiUrl(), axiosConfig)
            .then((res) => {
                const overview = res.data;
                const availableServers = overview.servers || [];
                const categories = (overview.categories && overview.categories.length > 0)
                    ? overview.categories
                    : this.getDefaultCategories();

                this.setState((prevState) => ({
                    overview,
                    availableServers,
                    categories,
                    port: overview.default_port || prevState.port,
                    selectedCategory: prevState.selectedCategory !== "all" && categories.length > 0 && !categories.find(item => item.id === prevState.selectedCategory)
                        ? categories[0].id
                        : prevState.selectedCategory,
                    selectedServer: prevState.selectedServer ? prevState.selectedServer : "all"
                }));

                if (!silent) {
                    this.setInspector("Redis Overview", overview);
                    this.setSuccessMessage("Redis overview refreshed.");
                }
            })
            .catch((error) => {
                const message = this.buildErrorMessage(error);
                this.setErrorMessage(message);
                this.setInspector("Redis Overview Error", {
                    error: message
                });
            })
            .finally(() => {
                this.setState({loadingOverview: false});
            });
    }

    loadStats = (silent = false) => {
        const axiosConfig = this.getAxiosConfig({
            ...this.buildServerParams(),
            pattern: this.state.pattern,
            limit: this.state.limit,
            include_memory: this.state.includeMemory ? 1 : 0
        });

        if (!axiosConfig) {
            return Promise.resolve();
        }

        this.setState({loadingStats: true});

        return apiClient.get(this.getApiUrl("/stats"), axiosConfig)
            .then((res) => {
                this.setState({
                    statsResponse: res.data
                });

                this.setInspector("Redis Stats", res.data);

                if (!silent) {
                    this.setSuccessMessage("Redis stats refreshed.");
                }
            })
            .catch((error) => {
                const message = this.buildErrorMessage(error);
                this.setErrorMessage(message);
                this.setInspector("Redis Stats Error", {
                    error: message
                });
            })
            .finally(() => {
                this.setState({loadingStats: false});
            });
    }

    loadKeys = (silent = false) => {
        const axiosConfig = this.getAxiosConfig(this.buildListParams());

        if (!axiosConfig) {
            return Promise.resolve();
        }

        this.setState({loadingKeys: true});

        return apiClient.get(this.getApiUrl("/keys"), axiosConfig)
            .then((res) => {
                this.setState({
                    keysResponse: res.data,
                    lastKeysMode: "keys"
                });

                if (!silent) {
                    this.setInspector("Redis Keys", res.data);
                    this.setSuccessMessage("Redis keys loaded.");
                }
            })
            .catch((error) => {
                const message = this.buildErrorMessage(error);
                this.setErrorMessage(message);

                if (!silent) {
                    this.setInspector("Redis Keys Error", {
                        error: message
                    });
                }
            })
            .finally(() => {
                this.setState({loadingKeys: false});
            });
    }

    loadCategoryKeys = (categoryOverride = null, silent = false) => {
        const selectedCategory = categoryOverride || this.state.selectedCategory;
        const axiosConfig = this.getAxiosConfig({
            ...this.buildServerParams(),
            limit: this.state.limit,
            include_memory: this.state.includeMemory ? 1 : 0,
            include_values: this.state.includeValues ? 1 : 0
        });

        if (!axiosConfig) {
            return Promise.resolve();
        }

        this.setState({
            loadingKeys: true,
            selectedCategory: selectedCategory
        });

        return apiClient.get(this.getApiUrl("/category/" + encodeURIComponent(selectedCategory)), axiosConfig)
            .then((res) => {
                this.setState({
                    keysResponse: res.data,
                    lastKeysMode: "category"
                });

                if (!silent) {
                    this.setInspector("Redis Category Keys", res.data);
                    this.setSuccessMessage("Category keys loaded.");
                }
            })
            .catch((error) => {
                const message = this.buildErrorMessage(error);
                this.setErrorMessage(message);

                if (!silent) {
                    this.setInspector("Redis Category Error", {
                        error: message
                    });
                }
            })
            .finally(() => {
                this.setState({loadingKeys: false});
            });
    }

    inspectKey = (keyOverride = null, serverOverride = null) => {
        const keyName = keyOverride || this.state.keyName;

        if (!keyName) {
            this.setErrorMessage("Enter a key first.");
            return;
        }

        const axiosConfig = this.getAxiosConfig({
            ...this.buildServerParams(serverOverride),
            key: keyName,
            value_limit: this.state.limit
        });

        if (!axiosConfig) {
            return;
        }

        this.setState({
            loadingKeys: true,
            keyName: keyName,
            selectedServer: serverOverride || this.state.selectedServer
        });

        apiClient.get(this.getApiUrl("/key"), axiosConfig)
            .then((res) => {
                this.setInspector("Redis Key Details", res.data);
                this.setSuccessMessage("Key details loaded.");
            })
            .catch((error) => {
                const message = this.buildErrorMessage(error);
                this.setErrorMessage(message);
                this.setInspector("Redis Key Error", {
                    error: message
                });
            })
            .finally(() => {
                this.setState({loadingKeys: false});
            });
    }

    runDeleteKey = (keyOverride = null, serverOverride = null) => {
        const keyName = keyOverride || this.state.keyName;

        if (!keyName) {
            this.setErrorMessage("Enter or select a key to delete.");
            return;
        }

        const axiosConfig = this.getAxiosConfig({
            ...this.buildServerParams(serverOverride),
            key: keyName
        });

        if (!axiosConfig) {
            return;
        }

        this.setState({actionLoading: true});

        apiClient.delete(this.getApiUrl("/key"), axiosConfig)
            .then((res) => {
                this.setInspector("Redis Delete Key", res.data);
                this.setSuccessMessage("Key deletion request completed.");
                this.loadStats(true);
                this.loadKeys();
            })
            .catch((error) => {
                const message = this.buildErrorMessage(error);
                this.setErrorMessage(message);
                this.setInspector("Redis Delete Key Error", {
                    error: message
                });
            })
            .finally(() => {
                this.setState({actionLoading: false});
            });
    }

    runDeletePattern = () => {
        if (!this.state.pattern || this.state.pattern === "*") {
            this.setErrorMessage("Set a specific pattern before deleting by pattern.");
            return;
        }

        const axiosConfig = this.getAxiosConfig({
            ...this.buildServerParams(),
            pattern: this.state.pattern
        });

        if (!axiosConfig) {
            return;
        }

        this.setState({actionLoading: true});

        apiClient.delete(this.getApiUrl("/keys"), axiosConfig)
            .then((res) => {
                this.setInspector("Redis Delete Pattern", res.data);
                this.setSuccessMessage("Pattern deletion request completed.");
                this.loadStats(true);
                this.loadKeys();
            })
            .catch((error) => {
                const message = this.buildErrorMessage(error);
                this.setErrorMessage(message);
                this.setInspector("Redis Delete Pattern Error", {
                    error: message
                });
            })
            .finally(() => {
                this.setState({actionLoading: false});
            });
    }

    runDeleteCategory = (categoryOverride = null) => {
        const selectedCategory = categoryOverride || this.state.selectedCategory;

        const axiosConfig = this.getAxiosConfig({
            ...this.buildServerParams()
        });

        if (!axiosConfig) {
            return;
        }

        this.setState({
            actionLoading: true,
            selectedCategory: selectedCategory
        });

        apiClient.delete(this.getApiUrl("/category/" + encodeURIComponent(selectedCategory)), axiosConfig)
            .then((res) => {
                this.setInspector("Redis Delete Category", res.data);
                this.setSuccessMessage("Category deletion request completed.");
                this.loadStats(true);
                this.loadCategoryKeys(selectedCategory);
            })
            .catch((error) => {
                const message = this.buildErrorMessage(error);
                this.setErrorMessage(message);
                this.setInspector("Redis Delete Category Error", {
                    error: message
                });
            })
            .finally(() => {
                this.setState({actionLoading: false});
            });
    }

    runFlushDb = () => {
        const axiosConfig = this.getAxiosConfig(this.buildServerParams());

        if (!axiosConfig) {
            return;
        }

        this.setState({actionLoading: true});

        apiClient.delete(this.getApiUrl("/flushdb"), axiosConfig)
            .then((res) => {
                this.setInspector("Redis Flush DB", res.data);
                this.setSuccessMessage("FLUSHDB completed.");
                this.setState({
                    keysResponse: null
                });
                this.loadStats(true);
            })
            .catch((error) => {
                const message = this.buildErrorMessage(error);
                this.setErrorMessage(message);
                this.setInspector("Redis Flush DB Error", {
                    error: message
                });
            })
            .finally(() => {
                this.setState({actionLoading: false});
            });
    }

    openConfirmModal(type, payload = {}) {
        let title = "";
        let body = "";
        const serverLabel = payload.server === "all" || !payload.server ? "all configured Redis servers" : payload.server;

        if (type === "delete_key") {
            title = "Delete Redis Key";
            body = "Delete key " + payload.key + " on " + serverLabel + "?";
        } else if (type === "delete_pattern") {
            title = "Delete Keys By Pattern";
            body = "Delete all keys matching pattern " + payload.pattern + " on " + serverLabel + "?";
        } else if (type === "delete_category") {
            title = "Delete Category";
            body = "Delete all keys in category " + payload.category + " on " + serverLabel + "?";
        } else if (type === "flush_db") {
            title = "Flush Redis DB";
            body = "Run FLUSHDB on " + serverLabel + "? This removes the active Redis database for that scope.";
        }

        this.setState({
            confirmModal: {
                show: true,
                type: type,
                title: title,
                body: body,
                payload: payload
            }
        });
    }

    closeConfirmModal = () => {
        this.setState({
            confirmModal: {
                show: false,
                type: null,
                title: "",
                body: "",
                payload: {}
            }
        });
    }

    executeConfirmModal = () => {
        const confirmModal = this.state.confirmModal;
        this.closeConfirmModal();

        if (confirmModal.type === "delete_key") {
            this.runDeleteKey(confirmModal.payload.key, confirmModal.payload.server);
        } else if (confirmModal.type === "delete_pattern") {
            this.runDeletePattern();
        } else if (confirmModal.type === "delete_category") {
            this.runDeleteCategory(confirmModal.payload.category);
        } else if (confirmModal.type === "flush_db") {
            this.runFlushDb();
        }
    }

    getStatsRows() {
        if (!this.state.statsResponse || !this.state.statsResponse.servers) {
            return [];
        }

        return this.state.statsResponse.servers.map((server) => {
            return {
                host: server.host,
                connected: server.connected ? "Yes" : "No",
                port: server.port !== null && server.port !== undefined ? server.port : "-",
                role: server.role || "-",
                version: server.redis_version || "-",
                db_size: server.db_size !== null && server.db_size !== undefined ? server.db_size : "-",
                clients: server.connected_clients !== null && server.connected_clients !== undefined ? server.connected_clients : "-",
                keys: server.matching_keys_count !== null && server.matching_keys_count !== undefined ? server.matching_keys_count : 0,
                bytes: server.matching_keys_bytes_human || "-",
                hits: server.keyspace_hits !== null && server.keyspace_hits !== undefined ? server.keyspace_hits : "-",
                misses: server.keyspace_misses !== null && server.keyspace_misses !== undefined ? server.keyspace_misses : "-",
                expired: server.expired_keys !== null && server.expired_keys !== undefined ? server.expired_keys : "-",
                evicted: server.evicted_keys !== null && server.evicted_keys !== undefined ? server.evicted_keys : "-",
                error: server.error || "-"
            };
        });
    }

    getCategoryRows() {
        const categoryMap = {};
        const categories = (this.state.categories && this.state.categories.length > 0)
            ? this.state.categories
            : this.getDefaultCategories();
        const statsResponse = this.state.statsResponse || {};
        const statsServers = statsResponse.servers || [];
        const aggregatedGroups = {};
        const fallbackGlobalGroups = statsResponse.global_model_groups || [];

        categories.forEach((category) => {
            categoryMap[category.id] = {
                id: category.id,
                label: category.label,
                prefixes: (category.prefixes || []).join(", "),
                count: 0,
                bytes_human: "0 B"
            };
        });

        statsServers.forEach((server) => {
            (server.model_groups || []).forEach((group) => {
                if (!aggregatedGroups[group.id]) {
                    aggregatedGroups[group.id] = {
                        id: group.id,
                        label: group.label,
                        count: 0,
                        bytes: 0
                    };
                }

                aggregatedGroups[group.id].count += Number(group.count || 0);
                aggregatedGroups[group.id].bytes += Number(group.bytes || 0);
            });
        });

        const groupsToRender = Object.keys(aggregatedGroups).length > 0
            ? Object.keys(aggregatedGroups).map((groupId) => ({
                ...aggregatedGroups[groupId],
                bytes_human: this.formatBytes(aggregatedGroups[groupId].bytes)
            }))
            : fallbackGlobalGroups;

        groupsToRender.forEach((group) => {
            if (!categoryMap[group.id]) {
                categoryMap[group.id] = {
                    id: group.id,
                    label: group.label,
                    prefixes: "",
                    count: 0,
                    bytes_human: "0 B"
                };
            }

            categoryMap[group.id].count = group.count;
            categoryMap[group.id].bytes_human = group.bytes_human || this.formatBytes(group.bytes || 0);
        });

        return Object.keys(categoryMap).map((categoryId) => categoryMap[categoryId]);
    }

    getCategoryOptions() {
        return [
            {
                id: "all",
                label: "All Categories"
            },
            ...((this.state.categories && this.state.categories.length > 0)
                ? this.state.categories
                : this.getDefaultCategories())
        ];
    }

    getFlattenedKeyRows() {
        if (!this.state.keysResponse || !this.state.keysResponse.servers) {
            return [];
        }

        const rows = [];

        this.state.keysResponse.servers.forEach((server) => {
            const keys = server.keys || [];

            keys.forEach((item) => {
                rows.push({
                    host: server.host,
                    connected: server.connected ? "Yes" : "No",
                    key: item.key,
                    type: item.type || "-",
                    ttl: item.ttl,
                    memory_human: item.memory_human || "-",
                    preview: this.renderPreviewValue(item.value_preview)
                });
            });
        });

        return rows;
    }

    formatCount(value, suffix = "") {
        if (value === null || value === undefined || value === "-") {
            return "-";
        }

        const numericValue = Number(value);

        if (Number.isNaN(numericValue)) {
            return String(value);
        }

        return numericValue.toLocaleString() + suffix;
    }

    getServerHitRatio(server) {
        if (!server) {
            return "N/A";
        }

        if (server.hit_ratio !== null && server.hit_ratio !== undefined && server.hit_ratio !== "") {
            const ratioValue = Number(server.hit_ratio);

            if (!Number.isNaN(ratioValue)) {
                return ratioValue.toFixed(2) + " %";
            }
        }

        const hits = Number(server.keyspace_hits || 0);
        const misses = Number(server.keyspace_misses || 0);
        const total = hits + misses;

        if (total <= 0) {
            return "N/A";
        }

        return ((hits / total) * 100).toFixed(2) + " %";
    }

    renderServerMetric(label, value, key) {
        return (
            <div key={key}>
                <div style={{fontSize: '12px', textTransform: 'uppercase', color: '#9AA4BF', letterSpacing: '0.4px'}}>
                    {label}
                </div>
                <div style={{fontSize: '16px', color: '#55607A', lineHeight: '1.3'}}>
                    {value}
                </div>
            </div>
        );
    }

    renderPreviewValue(value) {
        if (value === null || value === undefined) {
            return "";
        }

        if (typeof value === "string") {
            return value.length > 120 ? value.substring(0, 120) + "..." : value;
        }

        try {
            const previewString = JSON.stringify(value);
            return previewString.length > 120 ? previewString.substring(0, 120) + "..." : previewString;
        } catch (e) {
            return "[unavailable]";
        }
    }

    getStatsColumns() {
        return [
            {
                accessor: "host",
                Header: "Server",
                sortable: true
            },
            {
                accessor: "connected",
                Header: "Connected",
                maxWidth: 100,
                sortable: true
            },
            {
                accessor: "port",
                Header: "Port",
                maxWidth: 80,
                sortable: true
            },
            {
                accessor: "role",
                Header: "Role",
                maxWidth: 90,
                sortable: true
            },
            {
                accessor: "version",
                Header: "Version",
                maxWidth: 110,
                sortable: true
            },
            {
                accessor: "db_size",
                Header: "DB Size",
                maxWidth: 90,
                sortable: true
            },
            {
                accessor: "clients",
                Header: "Clients",
                maxWidth: 80,
                sortable: true
            },
            {
                accessor: "keys",
                Header: "Keys",
                maxWidth: 80,
                sortable: true
            },
            {
                accessor: "bytes",
                Header: "Size",
                maxWidth: 110,
                sortable: true
            },
            {
                accessor: "hits",
                Header: "Hits",
                maxWidth: 90,
                sortable: true
            },
            {
                accessor: "misses",
                Header: "Misses",
                maxWidth: 90,
                sortable: true
            },
            {
                accessor: "expired",
                Header: "Expired",
                maxWidth: 90,
                sortable: true
            },
            {
                accessor: "evicted",
                Header: "Evicted",
                maxWidth: 90,
                sortable: true
            },
            {
                accessor: "error",
                Header: "Error",
                sortable: false
            },
            {
                accessor: "host",
                Header: "Actions",
                maxWidth: 90,
                sortable: false,
                filterable: false,
                Cell: row => (
                    <div className="actions-right">
                        <OverlayTrigger placement="top" overlay={this.state.use_tooltip}>
                            <Button
                                bsStyle="info"
                                simple
                                icon
                                onClick={() => this.setState({selectedServer: row.value})}
                            >
                                <i className="fa fa-crosshairs"/>
                            </Button>
                        </OverlayTrigger>
                    </div>
                )
            }
        ];
    }

    getCategoryColumns() {
        return [
            {
                accessor: "label",
                Header: "Category",
                sortable: true
            },
            {
                accessor: "count",
                Header: "Keys",
                maxWidth: 90,
                sortable: true
            },
            {
                accessor: "bytes_human",
                Header: "Size",
                maxWidth: 110,
                sortable: true
            },
            {
                accessor: "prefixes",
                Header: "Prefixes",
                sortable: false
            },
            {
                accessor: "id",
                Header: "Actions",
                maxWidth: 150,
                sortable: false,
                filterable: false,
                Cell: row => (
                    <div className="actions-right">
                        <OverlayTrigger placement="top" overlay={this.state.category_tooltip}>
                            <Button
                                bsStyle="info"
                                simple
                                icon
                                onClick={() => this.loadCategoryKeys(row.value)}
                            >
                                <i className="fa fa-folder-open"/>
                            </Button>
                        </OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={this.state.delete_tooltip}>
                            <Button
                                bsStyle="danger"
                                simple
                                icon
                                onClick={() => this.openConfirmModal("delete_category", {
                                    category: row.value,
                                    server: this.state.selectedServer
                                })}
                            >
                                <i className="fa fa-trash"/>
                            </Button>
                        </OverlayTrigger>
                    </div>
                )
            }
        ];
    }

    getKeyColumns() {
        return [
            {
                accessor: "host",
                Header: "Server",
                maxWidth: 150,
                sortable: true
            },
            {
                accessor: "key",
                Header: "Key",
                sortable: true
            },
            {
                accessor: "type",
                Header: "Type",
                maxWidth: 90,
                sortable: true
            },
            {
                accessor: "ttl",
                Header: "TTL",
                maxWidth: 80,
                sortable: true
            },
            {
                accessor: "memory_human",
                Header: "Size",
                maxWidth: 100,
                sortable: true
            },
            {
                accessor: "preview",
                Header: "Preview",
                sortable: false
            },
            {
                accessor: "key",
                Header: "Actions",
                maxWidth: 120,
                sortable: false,
                filterable: false,
                Cell: row => {
                    const rowData = row.original;

                    return (
                        <div className="actions-right">
                            <OverlayTrigger placement="top" overlay={this.state.info_tooltip}>
                                <Button
                                    bsStyle="info"
                                    simple
                                    icon
                                    onClick={() => this.inspectKey(rowData.key, rowData.host)}
                                >
                                    <i className="fa fa-search"/>
                                </Button>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top" overlay={this.state.delete_tooltip}>
                                <Button
                                    bsStyle="danger"
                                    simple
                                    icon
                                    onClick={() => this.openConfirmModal("delete_key", {
                                        key: rowData.key,
                                        server: rowData.host
                                    })}
                                >
                                    <i className="fa fa-trash"/>
                                </Button>
                            </OverlayTrigger>
                        </div>
                    );
                }
            }
        ];
    }

    renderSummaryCards() {
        const statsResponse = this.state.statsResponse;
        const servers = statsResponse && statsResponse.servers ? statsResponse.servers : [];
        const connectedServers = servers.filter((server) => server.connected).length;
        const totalKeys = servers.reduce((sum, server) => sum + (server.matching_keys_count || 0), 0);
        const totalBytes = servers.reduce((sum, server) => sum + (server.matching_keys_bytes || 0), 0);
        const totalCategories = this.getCategoryRows().length;
        const lastRefresh = this.state.lastAutoRefreshAt
            ? new Date(this.state.lastAutoRefreshAt).toLocaleTimeString()
            : null;

        const cards = [
            {
                label: "Servers",
                value: servers.length,
                subtext: connectedServers + " connected"
            },
            {
                label: "Matched Keys",
                value: totalKeys,
                subtext: this.state.pattern
            },
            {
                label: "Estimated Size",
                value: this.formatBytes(totalBytes),
                subtext: this.state.includeMemory ? "memory usage on" : "memory usage off"
            },
            {
                label: "Categories",
                value: totalCategories,
                subtext: this.state.selectedServer === "all" ? "all servers" : this.state.selectedServer
            }
        ];

        return (
            <div>
                <Row>
                    <Col sm={12}>
                        <div style={{marginBottom: '8px'}}>
                            <Label bsStyle={this.getAutoRefreshSeconds() > 0 ? "success" : "default"}>
                                Auto Refresh Summary: {this.getAutoRefreshSeconds() > 0 ? this.getAutoRefreshSeconds() + "s" : "Off"}
                            </Label>
                            {" "}
                            <Label bsStyle="info">
                                Last Refresh: {lastRefresh || "Not yet"}
                            </Label>
                        </div>
                    </Col>
                </Row>
                <Row>
                    {cards.map((item) => (
                        <Col md={3} sm={6} key={item.label}>
                            <Card
                                content={
                                    <div className="text-center">
                                        <h6 style={{textTransform: 'uppercase', color: '#9A9A9A', marginTop: 0}}>
                                            {item.label}
                                        </h6>
                                        <h3 style={{marginTop: 0, marginBottom: '6px'}}>
                                            {item.value}
                                        </h3>
                                        <span className="category">
                                            {item.subtext}
                                        </span>
                                    </div>
                                }
                            />
                        </Col>
                    ))}
                </Row>
            </div>
        );
    }

    renderAlerts() {
        if (this.state.errorMessage) {
            return (
                <div className="alert alert-danger">
                    {this.state.errorMessage}
                </div>
            );
        }

        if (this.state.successMessage) {
            return (
                <div className="alert alert-success">
                    {this.state.successMessage}
                </div>
            );
        }

        return null;
    }

    renderConfirmModal() {
        return (
            <Modal show={this.state.confirmModal.show} onHide={this.closeConfirmModal}>
                <Modal.Header closeButton style={{backgroundColor: '#fbfbfb'}}>
                    <Modal.Title>{this.state.confirmModal.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{this.state.confirmModal.body}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="default" fill onClick={this.closeConfirmModal}>
                        Cancel
                    </Button>
                    <Button bsStyle="danger" fill onClick={this.executeConfirmModal}>
                        Confirm
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    formatBytes(value) {
        if (!value && value !== 0) {
            return "0 B";
        }

        const bytes = Number(value);

        if (bytes < 1024) {
            return bytes + " B";
        }

        const units = ["KB", "MB", "GB", "TB"];
        let unitIndex = -1;
        let nextValue = bytes;

        while (nextValue >= 1024 && unitIndex < units.length - 1) {
            nextValue = nextValue / 1024;
            unitIndex++;
        }

        return nextValue.toFixed(nextValue >= 100 ? 0 : 2) + " " + units[unitIndex];
    }

    renderServerMonitorCards() {
        const servers = this.state.statsResponse && this.state.statsResponse.servers ? this.state.statsResponse.servers : [];

        return (
            <div>
                <Row>
                    <Col sm={12}>
                        <div style={{marginBottom: '15px'}}>
                            <h4 style={{margin: 0, color: '#555'}}>Server Monitor Cards</h4>
                            <p className="category" style={{marginTop: '6px', marginBottom: 0}}>
                                A visual Redis host view similar to the STB monitor, kept here as a second readout under the management tables.
                            </p>
                        </div>
                    </Col>
                </Row>
                <Row>
                    {servers.length > 0 ? servers.map((server) => {
                        const metrics = [
                            {label: "Uptime", value: server.uptime_seconds !== null && server.uptime_seconds !== undefined ? this.formatCount(server.uptime_seconds, " s") : "-"},
                            {label: "Ops / sec", value: this.formatCount(server.ops_per_sec || 0)},
                            {label: "Clients", value: this.formatCount(server.connected_clients)},
                            {label: "Memory", value: server.used_memory_human || "-"},
                            {label: "DB Size", value: server.db_size !== null && server.db_size !== undefined ? this.formatCount(server.db_size, " keys") : "-"},
                            {label: "Matched Keys", value: this.formatCount(server.matching_keys_count)},
                            {label: "Matched Size", value: server.matching_keys_bytes_human || "0 B"},
                            {label: "Hit Ratio", value: this.getServerHitRatio(server)},
                            {label: "Hits / Misses", value: this.formatCount(server.keyspace_hits || 0) + " / " + this.formatCount(server.keyspace_misses || 0)},
                            {label: "Expired Keys", value: this.formatCount(server.expired_keys || 0)},
                            {label: "Evicted Keys", value: this.formatCount(server.evicted_keys || 0)}
                        ];

                        return (
                            <Col md={3} sm={6} key={server.host} style={{marginBottom: '20px'}}>
                                <Card
                                    content={
                                        <div>
                                            <div style={{display: 'flex', alignItems: 'center', marginBottom: '4px'}}>
                                                <span style={{
                                                    display: 'inline-block',
                                                    padding: '4px 10px',
                                                    borderRadius: '999px',
                                                    fontSize: '12px',
                                                    fontWeight: 700,
                                                    color: server.connected ? '#2F855A' : '#C53030',
                                                    backgroundColor: server.connected ? '#E6FFED' : '#FDECEC'
                                                }}>
                                                    {server.connected ? "UP" : "DOWN"}
                                                </span>
                                                <span style={{marginLeft: '10px', fontSize: '20px', fontWeight: 600, color: '#2D3748', lineHeight: '1.2', wordBreak: 'break-word'}}>
                                                    {server.host}
                                                </span>
                                            </div>
                                            <div className="category" style={{fontSize: '13px', marginBottom: '14px'}}>
                                                Port <code>{server.port !== null && server.port !== undefined ? server.port : "-"}</code>
                                                {" "}• Ping: <code>{server.ping !== null && server.ping !== undefined ? String(server.ping) : "-"}</code>
                                                {" "}• Version: <code>{server.redis_version || "-"}</code>
                                                {" "}• Role: <code>{server.role || "-"}</code>
                                            </div>

                                            {!server.connected && server.error ? (
                                                <div style={{
                                                    borderRadius: '8px',
                                                    border: '1px solid #F5C6CB',
                                                    backgroundColor: '#FFF5F5',
                                                    padding: '8px 10px',
                                                    fontSize: '12px',
                                                    color: '#8A1F17',
                                                    marginBottom: '14px'
                                                }}>
                                                    <strong>Error:</strong> {server.error}
                                                </div>
                                            ) : null}

                                            <div style={{
                                                display: 'grid',
                                                gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                                                gap: '12px 18px'
                                            }}>
                                                {metrics.map((metric) => this.renderServerMetric(metric.label, metric.value, server.host + "_" + metric.label))}
                                            </div>
                                        </div>
                                    }
                                />
                            </Col>
                        );
                    }) : (
                        <Col sm={12}>
                            <Card
                                content={
                                    <p className="category" style={{marginBottom: 0}}>
                                        Load Redis stats to populate the server monitor cards.
                                    </p>
                                }
                            />
                        </Col>
                    )}
                </Row>
            </div>
        );
    }

    render() {
        const statsRows = this.getStatsRows();
        const categoryRows = this.getCategoryRows();
        const keyRows = this.getFlattenedKeyRows();

        return (
            <div>
                {this.renderConfirmModal()}

                <Row>
                    <Col sm={12}>
                        {this.renderAlerts()}
                    </Col>
                </Row>

                {this.renderSummaryCards()}

                <Row>
                    <Col sm={12}>
                        <Card
                            title={"Controls"}
                            category={"Read from one Redis host or all hosts, inspect keys, and run destructive actions with explicit scope."}
                            content={
                                <div>
                                    <Row>
                                        <Col md={3} sm={6}>
                                            <FormGroup>
                                                <ControlLabel>Server Scope</ControlLabel>
                                                <FormControl
                                                    componentClass="select"
                                                    name="selectedServer"
                                                    value={this.state.selectedServer}
                                                    onChange={this.handleInputChange}
                                                >
                                                    <option value="all">All Servers</option>
                                                    {(this.state.availableServers || []).map((server) => (
                                                        <option key={server.host} value={server.host}>
                                                            {server.host}:{server.port}
                                                        </option>
                                                    ))}
                                                </FormControl>
                                            </FormGroup>
                                        </Col>
                                        <Col md={3} sm={6}>
                                            <FormGroup>
                                                <ControlLabel>Category</ControlLabel>
                                                <FormControl
                                                    componentClass="select"
                                                    name="selectedCategory"
                                                    value={this.state.selectedCategory}
                                                    onChange={this.handleInputChange}
                                                >
                                                    {this.getCategoryOptions().map((category) => (
                                                        <option key={category.id} value={category.id}>
                                                            {category.label}
                                                        </option>
                                                    ))}
                                                </FormControl>
                                            </FormGroup>
                                        </Col>
                                        <Col md={2} sm={4}>
                                            <FormGroup>
                                                <ControlLabel>Port</ControlLabel>
                                                <FormControl
                                                    type="number"
                                                    min="1"
                                                    max="65535"
                                                    name="port"
                                                    value={this.state.port}
                                                    onChange={this.handleInputChange}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={4} sm={8}>
                                            <FormGroup>
                                                <ControlLabel>Pattern</ControlLabel>
                                                <FormControl
                                                    type="text"
                                                    name="pattern"
                                                    value={this.state.pattern}
                                                    onChange={this.handleInputChange}
                                                    placeholder="dev_siber_*"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={8} sm={12}>
                                            <FormGroup>
                                                <ControlLabel>Key</ControlLabel>
                                                <FormControl
                                                    type="text"
                                                    name="keyName"
                                                    value={this.state.keyName}
                                                    onChange={this.handleInputChange}
                                                    placeholder="dev_siber_menu_uId_5_cId_GR_appId_1_dType_web"
                                                />
                                                <HelpBlock>
                                                    For key inspection and single-key deletion, paste the full key or the key without the global Redis prefix.
                                                </HelpBlock>
                                            </FormGroup>
                                        </Col>
                                        <Col md={2} sm={6}>
                                            <FormGroup>
                                                <ControlLabel>Limit</ControlLabel>
                                                <FormControl
                                                    type="number"
                                                    min="1"
                                                    max="1000"
                                                    name="limit"
                                                    value={this.state.limit}
                                                    onChange={this.handleInputChange}
                                                />
                                            </FormGroup>
                                            <FormGroup>
                                                <ControlLabel>Auto Refresh (sec)</ControlLabel>
                                                <FormControl
                                                    type="number"
                                                    min="0"
                                                    max="3600"
                                                    name="autoRefreshSeconds"
                                                    value={this.state.autoRefreshSeconds}
                                                    onChange={this.handleInputChange}
                                                />
                                                <HelpBlock>
                                                    0 = off
                                                </HelpBlock>
                                            </FormGroup>
                                            <FormGroup style={{marginTop: '30px'}}>
                                                <Checkbox
                                                    name="includeMemory"
                                                    checked={this.state.includeMemory}
                                                    onChange={this.handleInputChange}
                                                >
                                                    Include memory
                                                </Checkbox>
                                            </FormGroup>
                                        </Col>
                                        <Col md={2} sm={6}>
                                            <FormGroup style={{marginTop: '30px'}}>
                                                <Checkbox
                                                    name="includeValues"
                                                    checked={this.state.includeValues}
                                                    onChange={this.handleInputChange}
                                                >
                                                    Include previews
                                                </Checkbox>
                                                <Checkbox
                                                    name="fullScan"
                                                    checked={this.state.fullScan}
                                                    onChange={this.handleInputChange}
                                                >
                                                    Full scan
                                                </Checkbox>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            }
                            legend={
                                <div className="buttons-with-margin center">
                                    <Button fill bsStyle="info" onClick={() => {
                                        this.clearMessages();
                                        this.loadOverview();
                                    }}>
                                        Refresh Overview
                                    </Button>
                                    <Button fill bsStyle="primary" onClick={() => {
                                        this.clearMessages();
                                        this.loadStats();
                                    }}>
                                        Load Stats
                                    </Button>
                                    <Button fill bsStyle="success" onClick={() => {
                                        this.clearMessages();
                                        this.loadKeys();
                                    }}>
                                        Search Keys
                                    </Button>
                                    <Button fill bsStyle="success" onClick={() => {
                                        this.clearMessages();
                                        this.loadCategoryKeys();
                                    }}>
                                        Load Category
                                    </Button>
                                    <Button fill bsStyle="warning" onClick={() => {
                                        this.clearMessages();
                                        this.inspectKey();
                                    }}>
                                        Inspect Key
                                    </Button>
                                    <Button fill bsStyle="danger" onClick={() => {
                                        this.clearMessages();

                                        if (!this.state.keyName) {
                                            this.setErrorMessage("Enter or select a key to delete.");
                                            return;
                                        }

                                        this.openConfirmModal("delete_key", {
                                            key: this.state.keyName,
                                            server: this.state.selectedServer
                                        });
                                    }}>
                                        Delete Key
                                    </Button>
                                    <Button fill bsStyle="danger" onClick={() => {
                                        this.clearMessages();

                                        if (!this.state.pattern || this.state.pattern === "*") {
                                            this.setErrorMessage("Set a specific pattern before deleting by pattern.");
                                            return;
                                        }

                                        this.openConfirmModal("delete_pattern", {
                                            pattern: this.state.pattern,
                                            server: this.state.selectedServer
                                        });
                                    }}>
                                        Delete Pattern
                                    </Button>
                                    <Button fill bsStyle="danger" onClick={() => {
                                        this.clearMessages();
                                        this.openConfirmModal("delete_category", {
                                            category: this.state.selectedCategory,
                                            server: this.state.selectedServer
                                        });
                                    }}>
                                        Delete Category
                                    </Button>
                                    <Button fill bsStyle="danger" onClick={() => {
                                        this.clearMessages();
                                        this.openConfirmModal("flush_db", {
                                            server: this.state.selectedServer
                                        });
                                    }}>
                                        Flush DB
                                    </Button>
                                    <Button fill bsStyle="default" onClick={this.props.onBack}>
                                        Back
                                    </Button>
                                    <Label bsStyle={this.getAutoRefreshSeconds() > 0 ? "success" : "default"}>
                                        Auto Refresh: {this.getAutoRefreshSeconds() > 0 ? this.getAutoRefreshSeconds() + "s" : "Off"}
                                    </Label>
                                </div>
                            }
                        />
                    </Col>
                </Row>

                <Row>
                    <Col md={7} sm={12}>
                        <Card
                            title={"Server Stats"}
                            category={"Connection health, key volume and Redis counters for the selected scope."}
                            content={
                                <ReactTableV6Simple
                                    data={statsRows}
                                    loading={this.state.loadingStats}
                                    columns={this.getStatsColumns()}
                                    defaultPageSize={5}
                                />
                            }
                        />
                    </Col>
                    <Col md={5} sm={12}>
                        <Card
                            title={"Category Totals"}
                            category={"Counts and sizes by cache category, based on the latest stats payload."}
                            content={
                                <ReactTableV6Simple
                                    data={categoryRows}
                                    loading={this.state.loadingStats}
                                    columns={this.getCategoryColumns()}
                                    defaultPageSize={5}
                                />
                            }
                        />
                    </Col>
                </Row>

                <Row>
                    <Col sm={12}>
                        <Card
                            title={"Keys"}
                            category={"Results from key search or category search. Use the action buttons to inspect or delete a specific key."}
                            content={
                                <ReactTableV6Simple
                                    data={keyRows}
                                    loading={this.state.loadingKeys || this.state.actionLoading}
                                    columns={this.getKeyColumns()}
                                    defaultPageSize={10}
                                />
                            }
                            legend={
                                <div>
                                    <Label bsStyle="default">
                                        Scope: {this.state.selectedServer === "all" ? "all servers" : this.state.selectedServer}
                                    </Label>{" "}
                                    <Label bsStyle="info">
                                        Category: {this.state.selectedCategory}
                                    </Label>{" "}
                                    <Label bsStyle="primary">
                                        Pattern: {this.state.pattern}
                                    </Label>
                                </div>
                            }
                        />
                    </Col>
                </Row>

                <Row>
                    <Col sm={12}>
                        <Card
                            title={this.state.inspectorTitle}
                            category={"Raw response payload from the latest Redis cache action."}
                            content={
                                <div style={{maxHeight: '700px', overflowY: 'auto'}}>
                                    {this.state.inspectorData ? (
                                        <ReactJson
                                            collapsed={1}
                                            enableClipboard={true}
                                            displayDataTypes={false}
                                            displayObjectSize={false}
                                            src={this.state.inspectorData}
                                        />
                                    ) : (
                                        <p className="category" style={{marginBottom: 0}}>
                                            Run an action to inspect the response here.
                                        </p>
                                    )}
                                </div>
                            }
                        />
                    </Col>
                </Row>

                {this.renderServerMonitorCards()}
            </div>
        );
    }
}

function mapStateToProps(state) {

    const {users, authentication} = state;
    const {user} = authentication;
    return {
        user,
        users
    };
}

const connectedDataRedisCacheManagement = connect(mapStateToProps)(DataRedisCacheManagement);
export {connectedDataRedisCacheManagement as DataRedisCacheManagement};
